import "./App.css";
import NavigationRouter from "./app/routes/routes";

function App() {
  return <NavigationRouter />;
}

export default App;
